import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Personal",
    items: [
      { label: "Empleados", icon: "fas fa-address-card", href: "/Empleados", perm: "menu_empleados" },
      { label: "Puestos",   icon: "fas fa-address-book", href: "/Puestos",   perm: "menu_puestos"   },
    ],
  },
];

function BotonesNominas() {
  return (
    <MenuGrid
      title="Empleados"
      subtitle="Personal y puestos de trabajo"
      icon="fas fa-id-badge"
      accent={{ color: "#6366f1", bg: "#eef2ff" }}
      gate="menu_nominas"
      sections={SECTIONS}
    />
  );
}

export default BotonesNominas;
